
import React from "react";
import { useNavigate } from "react-router-dom";
import { createLeaveType } from 'adminApi/LeaveApi/LeaveTypeApi';
import { validateForm } from "utils/validation";
import { LeaveTypeRules } from "validation/ValidationRules";
import Spinner from "Common/Globle/Spinner";
import AddLeaveTypeForm from "./Components/AddLeaveTypeForm";
import fields from "../json/LeaveTypeFields.json";
import useFormChange from "Hooks/useFormChange";
import useFormSubmit from "Hooks/useFormSubmit";

const AddLeaveType = () => {
    const navigate = useNavigate();
    const { formdata } = fields;

    // Initialize form values from JSON fields
    const initialValues = formdata.reduce((acc, field) => ({ ...acc, [field.name]: "" }), {});

    const { values, errors, handleChange } = useFormChange(
        initialValues,
        LeaveTypeRules
    );

    // Form submit handler
    const { loading: loadingSubmit, handleSubmit } = useFormSubmit(
        async (formValues) => {
            const formData = new FormData();
            Object.entries(formValues).forEach(([key, val]) => formData.append(key, val ?? ""));
            return await createLeaveType({ data: formData });
        },
        (vals) => validateForm(vals, LeaveTypeRules),
        () => navigate(-1),
        "Leave Type added successfully"
    );

    return (
        <>
            {(loadingSubmit) && <Spinner isSpinner={true} />}
            <AddLeaveTypeForm
                fields={formdata}
                values={values}
                errors={errors}
                handleChange={handleChange}
                handleSubmit={(e) => handleSubmit(e, values)}
                loading={loadingSubmit}
            />
        </>
    );
};

export default AddLeaveType;
